var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { i18nState } from 'redux-i18n';
import thunk from 'redux-thunk';
import authMiddleware from './middlewares/authMiddleware';
import languageMiddleware from './middlewares/languageMiddleware';
import placeOrderMiddleware from './middlewares/placeOrderMiddleware';
import startupMiddleware from './middlewares/startupMiddleware';
import wsConnectionMiddleware from './middlewares/wsConnectionMiddleware';
import orderFeeMiddleware from './middlewares/orderFeeMiddleware';
import marginEnableMiddleware from './middlewares/marginEnableMiddleware';
import priceQuantityIncrementMiddleware from './middlewares/priceQuantityIncrementMiddleware';
import level2monitorMiddleware from './middlewares/level2monitorMiddleware';
// reducers (sort by name)
import affiliate from './reducers/affiliateReducer';
import api from './reducers/apiReducer';
import apiKey from './reducers/apiKeyReducer';
import apiProcessing from './reducers/apiProcessingReducer';
import auth from './reducers/authReducer';
import confirmWithdraw from './reducers/confirmWithdrawReducer';
import verifyAddress from './reducers/verifyAddressReducer';
import verifyDevice from './reducers/verifyDeviceReducer';
import eotc from './reducers/eotcReducer';
import eotcWithdraw from './reducers/eotcWithdrawReducer';
import eotcSettlement from './reducers/eotcSettlementReducer';
import eotcPrices from './reducers/eotcPriceReducer';
import deposit from './reducers/depositReducer';
import loyaltyFee from './reducers/loyaltyFeeReducer';
import modal from './reducers/modalReducer';
import paginationMemory from './reducers/paginationReducer';
import productAttributes from './reducers/productAttributesReducer';
import productManifest from './reducers/productManifestReducer';
import recentTrades from './reducers/recentTradesReducer';
import resetPassword from './reducers/resetPasswordReducer';
import report from './reducers/reportReducer';
import sidePane from './reducers/sidePaneReducer';
import signup from './reducers/signupReducer';
import snackbar from './reducers/snackbarReducer';
import tickers from './reducers/tickersReducer';
import transfer from './reducers/transferReducer';
import transferRequest from './reducers/transferRequestReducer';
import transferRequestRequested from './reducers/transferRequestRequestedReducer';
import user from './reducers/userReducer';
import verifyEmail from './reducers/verifyEmailReducer';
import withdraw from './reducers/withdrawReducer';
import wsConnection from './reducers/wsConnectionReducer';
import interestBearingAccounts from './reducers/interestBearingAccountsReducer';
import apexCore from './apexCore';
import { marginReducer } from './reducers/marginReducers/marginReducer';
var composeEnhancers = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  actionsBlacklist: ['LEVEL1_LOADED', 'LEVEL_2_UPDATES', 'REGISTER_FIELD', 'ADD_TICKERS', 'ADD_RECENT_TRADE']
}) : compose;
var rootReducer = combineReducers({
  api: api,
  apiKey: apiKey,
  apexCore: apexCore,
  affiliate: affiliate,
  auth: auth,
  form: formReducer,
  eotc: eotc,
  eotcWithdraw: eotcWithdraw,
  eotcSettlement: eotcSettlement,
  eotcPrices: eotcPrices,
  i18nState: i18nState,
  margin: marginReducer,
  modal: modal,
  productAttributes: productAttributes,
  productManifest: productManifest,
  recentTrades: recentTrades,
  report: report,
  sidePane: sidePane,
  signup: signup,
  snackbar: snackbar,
  user: user,
  apiProcessing: apiProcessing,
  deposit: deposit,
  withdraw: withdraw,
  wsConnection: wsConnection,
  tickers: tickers,
  transfer: transfer,
  transferRequest: transferRequest,
  paginationMemory: paginationMemory,
  verifyEmail: verifyEmail,
  confirmWithdraw: confirmWithdraw,
  resetPassword: resetPassword,
  loyaltyFee: loyaltyFee,
  transferRequestRequested: transferRequestRequested,
  interestBearingAccounts: interestBearingAccounts,
  verifyAddress: verifyAddress,
  verifyDevice: verifyDevice
});
var store = createStore(rootReducer, undefined, composeEnhancers(applyMiddleware(level2monitorMiddleware, priceQuantityIncrementMiddleware, marginEnableMiddleware, languageMiddleware, placeOrderMiddleware, startupMiddleware, orderFeeMiddleware, authMiddleware, wsConnectionMiddleware, thunk)));
export default store;